import axiosInstanceNew from "../lib/axiosinstanceNew";

const EhcDiscover = class {

    constructor(){
        this.baseUrl="discoverycalls";
    }

  async List(id) {
    return (await axiosInstanceNew.get(`${this.baseUrl}?class_id=${id}`));
  }
  async Add(data= []) {
    return (await axiosInstanceNew.post(`${this.baseUrl}`,data));
  }
}

export default new EhcDiscover();